<template>
    <div>
        <div class="card mb-3" id="cashDesk">
            <div class="card-header headline cash-desk">
                <h2 class="text-white d-inline">صندوق</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12 mt-5" v-if="cashDesks === undefined || cashDesks.length < 1">
                        <h3 class="text-center no-item-alert">صندوق ثبت نشده است!</h3>
                    </div>
                    <div class="col-lg-3 mb-3" v-for="(item, index) in cashDesks">
                        <div class="card shadow" @click="onCardClicked(index)">
                            <div class="row p-2">
                                <div class="col-lg-12 mt-3">
                                    <h4 class="text-center">{{item.outSourceName}}</h4>
                                    <span>موجودی اولیه: </span>
                                    <span>{{item.debtor.toLocaleString()}}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--<div v-if="cashDesks.length > 7 && lastRespond.length > 7" class="col-lg-12 text-center mb-3" @click="getcashDesks">
                        <button class="btn btn-success">نمایش حساب های بیشتر</button>
                    </div>-->
                    <div class="col-lg-12">
                        <div class="sk-circle" id="loadings">
                            <div class="sk-circle1 sk-child"></div>
                            <div class="sk-circle2 sk-child"></div>
                            <div class="sk-circle3 sk-child"></div>
                            <div class="sk-circle4 sk-child"></div>
                            <div class="sk-circle5 sk-child"></div>
                            <div class="sk-circle6 sk-child"></div>
                            <div class="sk-circle7 sk-child"></div>
                            <div class="sk-circle8 sk-child"></div>
                            <div class="sk-circle9 sk-child"></div>
                            <div class="sk-circle10 sk-child"></div>
                            <div class="sk-circle11 sk-child"></div>
                            <div class="sk-circle12 sk-child"></div>
                        </div>
                    </div>
                    <div v-if="!autoload && cashDesks !== undefined && cashDesks.length < dataCount" class="col-lg-12 text-center mb-3" @click="getcashDesks">
                        <button class="btn btn-success">نمایش موارد بیشتر</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="cashDesk-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 v-if="params.mode === 'create'" class="modal-title text-white">افزودن موجودی اولیه</h5>
                        <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش موجودی اولیه</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 offset-lg-3 mb-2 text-center">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">موجودی اولیه</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="opening.price"
                                           @input="thousandSeprator(opening.price)">
                                </div>
                                <small class="text-nowrap mt-2">{{opening.priceshow}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'initial-cashDesk',
        components: {},
        data() {
            return {
                cashDesks: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    name: "",
                    type: 2
                },
                opening: {
                    code: "",
                    price: 0,
                    isDebtor: true,
                    voucherId: 0,
                    outsourceId: 0,
                },
                params: {
                    mode: 'create'
                },
                searchString: "",
                dataCount: 0,

                autoload: false,
                isSending: false,
            }
        },
        mounted() {
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                this.cashDesks = response.data.data;
                this.dataCount = response.data.count;
                $("#loadings").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.response.message, this.$noty);
            });

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.cashDesks.length < this.dataCount) {
                        $("#loading").show();
                        this.getCashDesks();
                    }
                });
            }
        },
        methods: {
            getcashDesks() {
                this.queryParams.pageIndex++;
                $("#loadings").show();
                new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                    this.cashDesks.push.apply(this.cashDesks, response.data.data);
                    $("#loadings").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onCardClicked(index) {
                if (this.cashDesks[index].voucherId === 0) {
                    this.params.mode = 'create';
                    this.opening.rowVersion = this.generateUuid();
                } else {
                    this.params.mode = 'edit';
                }
                this.opening.code = this.cashDesks[index].code;
                this.opening.price = this.cashDesks[index].debtor;
                this.opening.voucherId = this.cashDesks[index].voucherId;
                this.opening.outsourceId = this.cashDesks[index].id;
                $("#cashDesk-modal").modal("show");
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.opening);
                } else {
                    this.onUpdate(this.opening);
                }
            },
            onCreate(opening) {
                if (!this.isSending) {
                    this.isSending = true;
                    new BaseService('outsource', '/opening').create(opening).then(response => {
                        this.$noty.success("موجودی اولیه با موفقیت افزوده شد.");
                        $("#cashDesk-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                            this.cashDesks = response.data.data;
                            $("#loading").hide();
                            this.opening.code = "";
                            this.opening.price = 0;
                            this.opening.isDebtor = true;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onUpdate(opening) {
                if (!this.isSending) {
                    this.isSending = true;

                    new BaseService('outsource', '/opening').update(opening).then(response => {
                        this.$noty.success("موجودی اولیه با موفقیت ویرایش شد.");
                        $("#cashDesk-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('outsource', '/getopening').getList(this.queryParams).then(response => {
                            this.cashDesks = response.data.data;
                            $("#loading").hide();
                            this.opening.code = "";
                            this.opening.price = 0;
                            this.opening.isDebtor = true;
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            thousandSeprator(a) {

                let amount = a;
                let showprice = "";

                console.log(a);
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                console.log(showprice);
                this.opening.priceshow = showprice;
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#cashDesk-modal").hasClass("show")) {
                $("#cashDesk-modal").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>